import React from 'react'
import { useSelector } from 'react-redux'
import MovieList from "./MovieList"

const GptMovieSuggestions = () => {
  const geminiImage="https://www.silicon.co.uk/wp-content/uploads/2023/12/Google-Gemini-684x513.jpg"

  const gpt = useSelector(store => store.gpt)

  const { movieResult, movienames } = gpt;

  if (!movienames) return  <div className='flex items-center justify-center h-full w-full bg-black opacity-50'>
  <img className=' opacity-90  backdrop-blur-3xl' src={geminiImage} alt='gemini-image' />
</div>

  return (
    <div className='m-4 p-4 bg-black text-white bg-opacity-70'>
      {
        movienames.map((movieName, index) => < MovieList key={movieName} title={movieName} movies={movieResult[index]} />
        )
      }
    </div>
  )
}

export default GptMovieSuggestions